var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStackStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_8089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0236 5.88529C15 6.77057 15 8.19542 15 11.0451V12.2882C15 15.1379 15 16.5628 14.0236 17.448C13.0473 18.3333 11.476 18.3333 8.33329 18.3333C5.1906 18.3333 3.61925 18.3333 2.64294 17.448C1.66663 16.5628 1.66663 15.1379 1.66663 12.2882V11.0451C1.66663 8.19542 1.66663 6.77057 2.64294 5.88529C3.61925 5 5.1906 5 8.33329 5C11.476 5 13.0473 5 14.0236 5.88529Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0553 4.99984C5.14449 3.84328 5.37579 3.0957 5.97563 2.55179C6.95194 1.6665 8.52329 1.6665 11.666 1.6665C14.8087 1.6665 16.38 1.6665 17.3563 2.55179C18.3327 3.43708 18.3327 4.86193 18.3327 7.71162V8.95472C18.3327 11.8044 18.3327 13.2293 17.3563 14.1146C16.812 14.6081 16.0827 14.8265 14.9993 14.9231",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90921 8.81489L9.49581 9.99779C9.5758 10.1625 9.78911 10.3204 9.96909 10.3506L11.0323 10.5287C11.7122 10.643 11.8722 11.1404 11.3823 11.631L10.5557 12.4644C10.4157 12.6055 10.3391 12.8777 10.3824 13.0727L10.619 14.1043C10.8057 14.9209 10.3757 15.2368 9.65913 14.81L8.66257 14.2152C8.48259 14.1077 8.18596 14.1077 8.00265 14.2152L7.00609 14.81C6.29283 15.2368 5.85955 14.9176 6.0462 14.1043L6.28284 13.0727C6.32616 12.8777 6.24951 12.6055 6.10952 12.4644L5.28295 11.631C4.79633 11.1404 4.95298 10.643 5.63291 10.5287L6.69612 10.3506C6.87277 10.3204 7.08608 10.1625 7.16607 9.99779L7.75267 8.81489C8.07264 8.17303 8.59258 8.17303 8.90921 8.81489Z",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_8089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStackStar);
export default __webpack_public_path__ + "static/media/icon-stack-star.f644e985c1ec8f18717ba149e2d8b53a.svg";
export { ForwardRef as ReactComponent };